import { Expose, Type } from "class-transformer";

export class CreateWorksheetHasVehicleDto {
  @Expose()
  worksheetId: string;

  @Expose()
  driverId: string;

  @Expose()
  vehicleId?: string;

  @Expose()
  isOwnVehicle: boolean;

  @Expose()
  @Type(() => Number)
  km?: number;
}
